import styled from 'styled-components'; 

export const AlignRightContainer = styled.div`

    margin-top: ${props => (props.marginTop ? props.marginTop : '0px')};
    display: flex;
    justify-content: flex-end;
`
